import { Component } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-audit-button',
  standalone: true,
  imports: [MarkantElementsModule, RouterLink, TranslocoPipe],
  templateUrl: './audit-button.component.html',
  styleUrl: './audit-button.component.scss',
})
export class AuditButtonComponent {
  protected readonly LINK = 'history';
}
